module.exports = __webpack_public_path__ + "img/switzerland-digestive-diseases-female.a74c06dd.png";